<template>
  <div>
    <v-data-table :headers="headers" :items="skus" class="">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Services</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <button
            type="button"
            class="mb-2 btn btn-info px-5 py-3 ls1"
            @click="showAddSkuModal()"
          >
            New service
          </button>
        </v-toolbar>
      </template>
      <template v-slot:item.name="{ item }">
        <div>{{ getServiceName(item.id) }}</div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="showEditSkuModal(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="removeSkus(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <EditSku
      ref="editSku"
      :actionFunction="editSkus"
      :services="services"
      :pageLoader="pageLoader"
      :item="itemForEdit"
      :contract="contractId"
    ></EditSku>
    <AddSku
      ref="addSku"
      :actionFunction="addSku"
      :services="services"
      :pageLoader="pageLoader"
      :contract="null"
    ></AddSku>
  </div>
</template>

<script>
import EditSku from "@/own/components/finance/customers/serviceContainer/EditSku";
import AddSku from "@/own/components/finance/customers/serviceContainer/AddSku";
import Swal from "sweetalert2";
export default {
  name: "SkuDatatable",
  props: ["setSku", "skus", "services", "pageLoader", "contractId"],
  components: { EditSku, AddSku },
  data: () => ({
    dialog: false,
    editItem: null,
    headers: [
      { text: "ID", value: "id" },
      { text: "Name", value: "name" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  computed: {
    itemForEdit() {
      return this.editItem;
    },
  },
  methods: {
    getServiceName(id) {
      return this.services.find((service) => service.index == parseInt(id))
        ?.text;
    },
    showEditSkuModal(item) {
      this.editItem = item;
      this.$nextTick(() => {
        this.$refs.editSku.toggleModal();
      });
    },
    showAddSkuModal() {
      this.$refs.addSku.toggleModal();
    },
    addSku(items) {
      const copy = [...this.skus];
      const existingIds = copy.map((sku) => sku.id);

      // Filter out IDs that already exist in the skus array
      const newIds = items.filter((id) => !existingIds.includes(id));

      // Only add items with IDs that don't already exist
      if (newIds.length > 0) {
        const newItems = newIds.map((id) => ({ id }));
        copy.push(...newItems);
        this.setSku(copy);
      }
    },
    editSkus(item, old_item_id = null) {
      this.$nextTick(() => {
        // Clone the array
        const copy = [...this.skus];

        // Determine the ID to search for
        const searchId = old_item_id || item.id;

        // Find the index of the object
        const targetIndex = copy.findIndex(({ id }) => id === searchId);

        // Update or add the item
        if (targetIndex !== -1) {
          copy[targetIndex] = item;
        } else {
          copy.push(item);
        }

        // Update the state
        this.setSku(copy);
      });
    },
    removeSkus(item) {
      const copy = JSON.parse(JSON.stringify(this.skus));
      const targetIndex = copy.findIndex(({ id }) => id === item.id);
      targetIndex > -1
        ? copy.splice(targetIndex, 1)
        : Swal.fire({
            title: "Error",
            text: `Something went wrong!`,
            icon: "error",
            showConfirmButton: false,
            timer: 2500,
          });
      this.setSku(copy);
    },
  },
};
</script>
